import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "../../Drawer/DrawerCom"

import { ScrollOutBoxWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, ListBottomGradientWrap, ListTopGradientWrap, PaddingLeftRightWrap, ScrollBoxWrap } from "../../Drawer/DrawerStyle"
import { useCallback, useEffect, useState } from "react"
import SearchCom from "../../Drawer/SearchCom"
import { Column, Row } from "style/preset"
import ImgCom from "components/ImgCom"
import { BalanceTagCom, TrendingTagCom } from "../../Drawer/CommonComList"
import { useAppSelector } from "hooks/redux/hooks"
import { ChaingeTokenChain } from "types/baseType"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const tabList = [{
    index: 3,
    name: 'All'
}]

const DrawerAssetsBrc20Com = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {
    const { tokensByBrc20: tokens } = useAppSelector((state) => state.app)
    const [ dataList, setDataList ] = useState<ChaingeTokenChain[]>([])

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源
            setDataList(tokens)
        } else {
            // 清理资源
            setTabIndex(3)
            setDataList([])
        }
    }, [open, tokens])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 搜索
     * @param e 
     */
    const [filter, setFilter] = useState('')
    const fnSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        let filterVal = e.target.value
        filterVal = filterVal.toLowerCase()
        const tempList = tokens.filter((item: ChaingeTokenChain) => {
            return item.name.toLowerCase().includes(filterVal) || 
                item.symbol.toLowerCase().includes(filterVal)
        })
        setDataList(tempList)
        setTabIndex(3)
        // 控制滚动加载
        setFilter(filterVal)
        if(!filterVal) {
            setDataList(tokens.slice(0, 20))
        }
    }, [tokens])

    /**
     * 选择资产
     */
    const fnSelectAsset = (curAsset: ChaingeTokenChain) => {
        onComplete(curAsset)
        fnCloseWin()
    }

    /**
     * 切换标签
     */
    const [tabIndex, setTabIndex] = useState(1)
    const fnSwtichTab = (index: number) => {
        setTabIndex(index)
    }

    /**
     * 切换标签并更新数据
     */
    useEffect(() => {
        setDataList(tokens.slice(0, 20))
        document.querySelector('#scrollerBox')?.scrollTo({
            behavior: 'smooth',
            top: 0
        })
    }, [tabIndex, tokens])


    /**
     * 加载更多
     */
    const fnLoadMoreForAsset = useCallback(() => {
        if(filter) return
        if(tabIndex <= 2) return 
        const length = dataList.length;
        const tempNewDataSub = tokens.slice(length, length + 20);
        const newDataAry = [...dataList, ...tempNewDataSub];
        setDataList(newDataAry)
    }, [dataList, filter, tabIndex, tokens])

    const fnScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        if (scrollTop + clientHeight >= scrollHeight) {
            fnLoadMoreForAsset()
        }
    }, [fnLoadMoreForAsset])


    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap $isError={true}>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Select an asset</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="30px">Choose any of our 2000+ assets to swap or bridge</DrawerWinTwoTileWrap>
                <SearchCom onChange={fnSearchChange}></SearchCom>
                <StyledContainer $height="20px"></StyledContainer>
                <TabListWrap>
                    {
                        tabList.map((item, index) => <TabBtnWrap $active={item.index === tabIndex} onClick={() => fnSwtichTab(item.index)} key={index}>{item.name}</TabBtnWrap>)
                    }
                </TabListWrap>
            </PaddingLeftRightWrap>
            <ScrollOutBoxWrap>
                <ListTopGradientWrap></ListTopGradientWrap>
                <ListBottomGradientWrap></ListBottomGradientWrap>
                <ScrollBoxWrap id="scrollerBox" onScroll={fnScroll}>
                    <StyledContainer $height="30px"></StyledContainer>
                    {
                        dataList.map((item: ChaingeTokenChain, index) => <AssetsItemCom isTrend={tabIndex === 2} onClick={() => fnSelectAsset(item)} detail={item} key={index}></AssetsItemCom>)
                    }
                    <StyledContainer $height="30px"></StyledContainer>
                </ScrollBoxWrap>
            </ScrollOutBoxWrap>
        </DrawerContentWrap>
    </DrawerCom> : <></>
}


interface AssetsItemProps {
    detail: ChaingeTokenChain
    isTrend?: boolean
    onClick?: () => void
}
const AssetsItemCom = ({detail, isTrend = false, onClick = () => {}}:AssetsItemProps) => {
    return <AssetsCardWrap onClick={onClick}>
        <Row $pointer $justifyContent="space-between" $flex1="1" $mr="8px">
            <Row>
                <ImgCom imgUrl={detail?.imgUrl as string}></ImgCom>
                <Column $ml="10px">
                    <StyledContainer $fontSize="16px" $lineHeight="18px" >{detail.symbol}</StyledContainer>
                    <StyledContainer $fontSize="12px" $lineHeight="14px">{detail.name}</StyledContainer>
                </Column>
            </Row>
            {
                isTrend && <TrendingTagCom></TrendingTagCom>
            }
        </Row>
        <BalanceTagCom></BalanceTagCom>
    </AssetsCardWrap>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    height: 100%;
    ${
        ({$isError, theme}) => $isError ? css`
         
        ` : css`
        `
    }
`

const TabListWrap = styled(Row)``

const TabBtnWrap = styled(StyledContainer)<{$active: boolean}>`
    padding: 8px 10px;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    border-radius: 6px;
    cursor: pointer;

    background-color: ${({$active, theme}) => $active ? theme.basicPurple : '#F6F5F4'} ;
    color: ${({$active, theme}) => $active ? theme.basicWhite : theme.basicBlack} ;
    margin-right: 5px;

`

const AssetsCardWrap = styled(Row)`
    padding: 12px 20px;
    justify-content: space-between;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    border-radius: 9px;
    background-color: ${({theme}) => theme.basicWhite};
    margin-bottom: 10px;
    &:hover {
        box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
    }
`

export default DrawerAssetsBrc20Com